import { ApiResponse } from "@twiliointernal/e2-commons-shared-definitions";

const handleResponse = async <Type>(
  response: Response
): Promise<ApiResponse<Type>> => {
  const { status: statusCode } = response;
  const contentType = response.headers.get("content-type");
  const isJson = contentType?.includes("application/json");

  if (isJson) {
    const jsonResponse = (await response.json()) as ApiResponse<Type>;

    if (!response.ok) {
      return {
        statusCode,
        ...jsonResponse,
      };
    }

    return {
      statusCode,
      ...jsonResponse,
    };
  }

  return response;
};

export { handleResponse };
